import { ComponentProps } from "react";
import Card from "@particles/card/Card";
import TopStoriesCard from "@particles/card/templates/TemplateE/components/TopStoriesCard";

type TemplateEProps = {
  /** The articles to be displayed in the section */
  cardProps: ComponentProps<typeof Card>[];
  /** Optional className for the section */
  className?: string;
  /** Optional link params */
  linkParams?: URLSearchParams;
};

/**
 * TopStories section component to display a list of top stories section.
 * It renders a section with a title and a list of articles as cards.
 * https://www.figma.com/design/rR8akVWS3SksIyaOSqetu4/BAU--WEB-?node-id=13060-44324&t=5ID3HBaQRGh7o2Lq-0
 */
const TemplateE = ({
  cardProps,
  className,
}: TemplateEProps): React.ReactElement | null => {
  if (!cardProps.length) return null;

  return (
    <section
      data-testid="global-top-stories-section-component"
      className={className}
    >
      <div className="grid w-full gap-8 md:grid-cols-12">
        {cardProps.map((cardProps, index) => (
          <TopStoriesCard
            key={cardProps.id}
            cardProps={cardProps}
            index={index}
          />
        ))}
      </div>
    </section>
  );
};

export default TemplateE;
